export default {
    login: {
        email: 'Courriel',
        password: 'Mot de passe',
        remember: 'Se souvenir de moi',
        connect: 'Connexion',
        forgotPassword: 'Mot de passe oublié?',
        failed: 'Ces informations d\'identification sont incorrectes.',
    },
    forgotPassword: {
        pageTitle: 'Mot de passe oublié',
        email: 'Courriel',
        instructions: 'Entrez le courriel associé au compte pour lequel vous souhaitez réinitialiser le mot de passe.',
        userNotFound: 'Ce courriel n\'est associé à aucun utilisateur.',
        invalidEmail: 'Le courriel saisi n\'est pas valide.',
        unknownError: 'Une erreur inconnue est survenue.',
        emailSentTitle: 'Courriel envoyé',
        emailSentText: 'Un courriel de réinitialisation de mot de passe a été envoyé à votre adresse courriel.',
    },
    newPassword: {
        pageTitle: 'Nouveau de mot de passe',
        instructions: 'Veuillez entrer un nouveau mot de passe (minimum 8 caractères).',
        password: 'Mot de passe',
        passwordConfirmation: 'Ressaisissez le mot de passe',
        changePassword: 'Changer le mot de passe',
        passwordChanged: 'Le mot de passe a été changé avec succès.',
    },
};
